export default "__VITE_ASSET__D1a5nF3v__"